import { ApiEndPoints, NetworkManager } from "../network";

export class AshaBlockServices {
  static getAshaBlock = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashaBlocks
    });
  };
  static getAllAshaBlocks = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashaBlocks,
      params: { fetchAll: true },
    });
  };
  static addAshaBlock = (ashaBlock, phcId) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.ashaBlocks,
      data: { ...ashaBlock, ...phcId },
    });
  };

  static updateAshaBlock = (id, ashaBlock, phcId) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.ashaBlocks,
      data: { ...id, ...ashaBlock, ...phcId },
    });
  };

  static deleteAshaBlock = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "delete",
      url: ApiEndPoints.ashaBlocks + "/" + id,
      data: { ...id },
    });
  };
  static geAshaBlockByPhcId = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaBlockByPhcId + id,
      // data: { ...id },
    });
  };

  static geAshaBlockById = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaBlockById + id,
      // data: { ...id },
    });
  };

  static getAshaBlockByTalukId = (talukId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaBlockByTalukId + talukId
    });
  };
}
